/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestCapturePointsMessageSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_CAPTURE_POINTS_MESSAGE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class AutoTestCapturePointsMessageSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestCapturePointsMessageSettingParser.decode(input).map(res => new AutoTestCapturePointsMessageSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestCapturePointsMessageSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestCapturePointsMessageSettingParser.encode(data);
    }
    static schema() {
        return AutoTestCapturePointsMessageSettingParser.schema();
    }
}
